<template>
  <div class="login">
    <!-- <div class="head">
      <div class="head_img">
        <img src="../../assets/img/logo.jpeg" alt="" />
      </div>
      <div class="title">系统</div>
    </div> -->
    <div class="content" style="">
      <img style="width:100%;height:100%;" src="../../assets/loginImages/login_bg.png" alt="" />
      <div class="bgColor"></div>
      <div v-if="login_title" class="login_title" style="color:#fff;">
        <p style="font-size: 64px;line-height: 75px;">Hi，你好!</p>
        <p style="font-size: 58px;line-height: 68px;margin-top:32px;">欢迎进入{{name}}</p>
        <!-- <p style="font-size: 24px;line-height: 28px;margin-top:32px;">Welcome to one-stop office system</p> -->
      </div>
      <div class="form_data" :style="phoneLogin?'bottom: 13%;':'bottom:24%;'">
        <!-- <h1>密码登录</h1> -->
        <p style="text-align:center;margin-bottom: 20px">
          <!-- <img style="width:226px;" src="../../assets/loginImages/logo-login.png" /> -->
          <span style="font-size:26px;color:#437afa;">{{name}}</span>
        </p>
        <el-form class="form" :model="formData" :rules="formRule" ref="form">
          <!-- <el-form-item v-if="phoneLogin" prop="phone">
            <el-input v-model="formData.phone" :placeholder="``" :maxlength="11" prefix-icon="el-icon-user"></el-input>
          </el-form-item> -->
          <el-form-item prop="username">
             <!-- :disabled="passwordLogin&&formData.originSign?false:true" -->
            <el-input @change="userchange()" v-model="formData.username" :placeholder="``" prefix-icon="el-icon-user"></el-input>
          </el-form-item>
          <el-form-item v-if="passwordLogin" prop="password" :style="phoneLogin?'':'margin-bottom:6px;'">
            <el-input type="password" v-model="formData.password" :placeholder="``" prefix-icon="el-icon-lock" show-password></el-input>
          </el-form-item>
          <el-form-item v-if="phoneLogin&&formData.originSign==''" prop="code" class="code-input" style="margin-bottom:6px;">
            <el-input v-model="formData.code" :placeholder="``" :maxlength="6">
              <template slot="append">
                <el-button @click="getCodeLogin()" type="text" :disabled="getCodeBtnDisableLogin" size="mini" style="margin-right:0px;">{{codeBtnWordLogin}}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item v-if="passwordLogin" style="margin-bottom:10px;">
            <el-checkbox class="remember" v-model="checked" checked>记住密码</el-checkbox>
            <el-button @click="getresetPassword" type="text" class="forget"> 忘记密码？ </el-button>
          </el-form-item>
          <el-button v-if="formData.originSign==''" @click.prevent="handleSubmit()" native-type="submit" type="primary" class="submit">
            登录
          </el-button>
          <el-button v-if="formData.originSign" @click.prevent="getLogin()" native-type="submit" type="primary" class="submit" :disabled="loginLoding">
            一键登录
          </el-button>
          <p style="text-align:right;padding-top:10px;margin-bottom:0;">
            <el-button @click="loginDing()" type="text">钉钉登录</el-button>
          </p>
          <!-- <p style="text-align:right;padding-top:10px;">
            <router-link style="color:#23848b" :to="{path:'/privacyPolicy'}" target="_blank" tag="a">隐私政策</router-link>
          </p> -->
        </el-form>
      </div>

      <div class="footer">
        <p>
          <!-- 版权所有 Copyright(C) 2013-2021 科技有限公司 粤ICP备2021128537号-1<br /> -->
        </p>
      </div>
    </div>

    <!-- 重置密码 -->
    <el-dialog title="重置密码" :visible.sync="resetdialog" :close-on-click-modal="false" :close-on-press-escape="false" width="520px">
      <el-form :model="resetform" :rules="resetrules" ref="resetform">
        <el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
          <el-input v-model="resetform.phone" autocomplete="off" size="mini" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="验证码" :label-width="formLabelWidth" prop="code">
          <el-input v-model="resetform.code" autocomplete="off" size="mini" style="width:300px;"></el-input>
          <el-button @click="getCode()" type="primary" :class="getCodeBtnDisable?'disabled-style':''" :disabled="getCodeBtnDisable" size="mini" style="font-size:12px;">
            {{codeBtnWord}}
          </el-button>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth" prop="password">
          <el-input type="password" v-model="resetform.password" autocomplete="off" size="mini" prefix-icon="el-icon-lock" show-password style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth" prop="password_confirmation">
          <el-input type="password" v-model="resetform.password_confirmation" autocomplete="off" size="mini" prefix-icon="el-icon-lock" show-password style="width:300px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetresetForm('resetform')" size="mini">取 消</el-button>
        <el-button type="primary" @click="submitresetForm('resetform')" size="mini">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 重置密码end -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { requestLogin,loginUserPermissions,userVerify,endconfirm,resetPassword,sendCode,pdd,dingTalkUrl,softInfo } from '@/api/api.js'
import { getdata } from '@/api/apimock.js'
import { initDynamicRoutes } from '@/router/index.js'
export default {
  // 定义属性
  data() {
    var validatePass1 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.resetform.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      name:'',
      phoneLogin:false,
      passwordLogin:true,
      formData: {
        username: "",
        password: "",
        originSign:'',
        code:'',
      },
      checked:true,
      formRule: {
        // phone: [
        //   { required: true, message: '请输入手机号', trigger: 'blur' },
        //   { pattern: /^1[3456789]\d{9}$/,message: '请输入合法手机号',trigger: 'blur' },
        // ],
        code: [{ required: true, message: `请输入验证码`, trigger: "blur" }],
        username: [{ required: true, message: `请输入账号/手机号`, trigger: "blur" }],
        password: [{ required: true, message: `请输入密码`, trigger: "blur" }],
      },
      loginLoding:false,
      resetdialog:false,//重置密码
      formLabelWidth: '120px',
      resetform:{
        phone:'',
        code:'',
        password:'',
        password_confirmation:''
      },
      resetrules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/,message: '请输入合法手机号',trigger: 'blur' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true,validator: validatePass1, trigger: 'blur' }
        ],
      },//重置密码end
      codeBtnWord: '获取验证码', // 获取验证码按钮文字
      waitTime:61, // 获取验证码按钮失效时间
      getCodeBtnDisable:false,
      login_title:true,
      //登录获取验证码
      codeBtnWordLogin: '获取验证码', // 获取验证码按钮文字
      getCodeBtnDisableLogin:false,
      waitTimeLogin:61, // 获取验证码按钮失效时间
      recordsArr:[],
    };
  },
  computed: {
    // ...mapState(['passwordLogin']),
    phoneRegex() {
      return /^1[3456789]\d{9}$/;
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    let sign = this.getQueryString('sign');
    if(sign){
      let params = {
        sign:sign
      }
      softInfo(params).then(res => {
        if(res.data.code == 200){
          let { name } = res.data.data.info
          this.name=name;
        }else{
          this.name='一站式办公系统';
        }
      })
    }else{
      this.name='一站式办公系统';
    }
    if(document.documentElement.clientWidth<800){
      this.login_title=false;
    }else{
      this.login_title=true;
    }
    if(localStorage.getItem('phone')&&localStorage.getItem('phone')!='undefined'){
      this.formData.username=localStorage.getItem('phone');
    }else{
      this.formData.username='';
    }
    if(localStorage.getItem('recordsArr')&&localStorage.getItem('recordsArr')!='undefined'){
      this.recordsArr=JSON.parse(localStorage.getItem('recordsArr'));
      let records = this.recordsArr.findIndex(item => {
        return item.phone == this.formData.username;
      });
      if(records==-1){
        this.phoneLogin=true;
        this.formData.originSign='';
      }else{
        this.formData.originSign=this.recordsArr[records].originSign;
        this.phoneLogin=false;
      }
    }else{
      this.phoneLogin=true;
      this.formData.originSign='';
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    loginDing(){
      var url = this.$store.state.dingdingurl;
      let para = {
        redirect_uri:url,
        type:1,
        token:''
      }
      dingTalkUrl(para).then(res => {
        if(res.data.code == 200){
          window.location.href = res.data.data;
        }
      })
    },
    userchange(){
      if(localStorage.getItem('recordsArr')&&localStorage.getItem('recordsArr')!='undefined'){
        this.recordsArr=JSON.parse(localStorage.getItem('recordsArr'));
        let records = this.recordsArr.findIndex(item => {
          return item.phone == this.formData.username;
        });
        if(records==-1){
          this.phoneLogin=true;
        this.formData.originSign='';
        }else{
          this.formData.originSign=this.recordsArr[records].originSign;
          this.phoneLogin=false;
        }
      }else{
        this.phoneLogin=true;
        this.formData.originSign='';
      }
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if(valid){
          this.getLogin();
        }
      })
    },
    getLogin(){
          this.loginLoding=true;
          let params = {
            username:this.formData.username,
            password:this.passwordLogin?this.formData.password:'',
            originSign:this.formData.originSign,
            code:this.phoneLogin?this.formData.code:'',
          }
          requestLogin(params).then(res => {
            if(res.data.code == 200){
              this.$message({message: res.data.msg,type: 'success',duration:2000});
              this.$store.dispatch('setToken',res.data.data.token);
              localStorage.setItem('token',res.data.data.token);
              this.$store.dispatch('getuserInfo',res.data.data);
              localStorage.setItem('user_info',JSON.stringify(res.data.data));
              localStorage.setItem('originSign',res.data.data.origin_sign);
              localStorage.setItem('phone',res.data.data.phone);
              this.recordsArr=[];
              if(localStorage.getItem('recordsArr')&&localStorage.getItem('recordsArr')!='undefined'){
                this.recordsArr=JSON.parse(localStorage.getItem('recordsArr'));
                let records = this.recordsArr.findIndex(item => {
                  return item.phone == this.formData.username;
                });
                if(records==-1){
                  this.recordsArr.push({phone:res.data.data.phone,originSign:res.data.data.origin_sign});
                  localStorage.setItem('recordsArr',JSON.stringify(this.recordsArr));
                }else{
                  this.recordsArr[records].phone=res.data.data.phone;
                  this.recordsArr[records].originSign=res.data.data.origin_sign;
                  localStorage.setItem('recordsArr',JSON.stringify(this.recordsArr));
                }
              }else{
                this.recordsArr=[{phone:res.data.data.phone,originSign:res.data.data.origin_sign}];
                localStorage.setItem('recordsArr',JSON.stringify(this.recordsArr));
              }
              loginUserPermissions({type:2}).then(permissionsRes => {
                if(permissionsRes.data.code == 200 ){
                  this.loginLoding=false;
                  this.$store.commit('setRightList',permissionsRes.data.data);
                  initDynamicRoutes();
                  if(permissionsRes.data.data.length){

                    let routeData=permissionsRes.data.data;
                    let settagsList=[{
                      title: routeData[0].children[0].route!=''?routeData[0].children[0].menu_name:routeData[0].children[0].children[0].menu_name,
                      path: routeData[0].children[0].route!=''?routeData[0].children[0].route:routeData[0].children[0].children[0].route,
                      name: routeData[0].children[0].route!=''?routeData[0].children[0].menu_name:routeData[0].children[0].children[0].menu_name,
                    }];
                    localStorage.setItem('settagsList',JSON.stringify(settagsList));
                    this.$router.push(routeData[0].children[0].route!=''?routeData[0].children[0].route:routeData[0].children[0].children[0].route);
                    localStorage.setItem('activePath',routeData[0].children[0].route!=''?routeData[0].children[0].route:routeData[0].children[0].children[0].route);

                    userVerify().then(verifyRes => {
                      if(verifyRes.data.data.confirm == 0){
                        let titleName = `${verifyRes.data.data.month}月的任务金额为：${verifyRes.data.data.money}元, 请确认是否正常?`
                        this.$confirm(titleName, '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
                          endconfirm({user_id:res.data.data.id,month:verifyRes.data.data.month}).then(endconfirmRes => {
                            if(endconfirmRes.data.code==200){
                              this.$message({ duration: 2000,showClose: true,message: '确认任务成功',type: 'success' });
                              this.getcommon();
                            }else{
                              this.$message({ duration: 2000,showClose: true,message: endconfirmRes.data.msg,type: 'error' });
                            }
                          });
                        }).catch(() => {
                          this.$message({ duration: 2000,showClose: true,type: 'info',message: '已取消'});
                        });
                      }
                    });
                  }else{
                    this.$message({ duration: 2000,showClose: true,message: '您暂无功能权限，请联系管理员！',type: 'error' });
                  }
                }
              })
            }else if(res.data.code == 10006){
              this.loginLoding=false;
              this.$message({ duration: 2000,showClose: true,message: '唯一标识错误或过期，需要验证码登陆',type: 'error' });
              this.phoneLogin=true;
              this.passwordLogin=true;
              // this.$store.dispatch('setpasswordLogin', false);
              localStorage.setItem('originSign','');
              this.formData.originSign='';
            }else{
              this.loginLoding=false;
              this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
            }
          });
    },
    //重置密码
    getresetPassword(data){
      this.resetdialog=true;
    },
    submitresetForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('此操作将重置该用户密码, 是否继续?', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(() => {
            let parmas = this.resetform;
            resetPassword(parmas).then(res => {
              if(res.data.code==200){
                this.resetdialog=false;
                this.$message({ duration: 2000,showClose: true,message: '重置密码成功',type: 'success' });
                this.$refs[formName].resetFields();
              }else{
                this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
              }
            });
          }).catch(() => {
            this.$message({ duration: 2000,showClose: true,type: 'info',message: '已取消重置密码'});
          });
        } else {
          return false;
        }
      });
    },
    resetresetForm(formName) {
      this.resetdialog=false;
      this.$refs[formName].resetFields();
    },
    //重置密码end
    getCode(){
      if(this.resetform.phone==''){
        this.$message({ duration: 2000,showClose: true,message: '请输入手机号',type: 'error' });
        return false;
      }
      if(!this.phoneRegex.test(this.resetform.phone)){
        this.$message({ duration: 2000,showClose: true,message: '请输入合法手机号',type: 'error' });
        return false;
      }
      if(this.resetform.phone){
        sendCode({phone:this.resetform.phone}).then(res => {
          if(res.data.code==200){
            this.$message({ duration: 2000,showClose: true,message: '验证码发送成功,10分钟内有效',type: 'success' });
          }else{
            this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
          }
        });
        // 因为下面用到了定时器，需要保存this指向
        let that = this
        that.waitTime--
        that.getCodeBtnDisable = true
        this.codeBtnWord = `${this.waitTime}s 后重新获取`
        let timer = setInterval(function(){
          if(that.waitTime>1){
            that.waitTime--
            that.codeBtnWord = `${that.waitTime}s 后重新获取`
          }else{
            clearInterval(timer)
            that.codeBtnWord = '获取验证码'
            that.getCodeBtnDisable = false
            that.waitTime = 61
          }
        },1000);
      }
    },
    //登录获取验证码
    getCodeLogin(){
      if(this.formData.username==''){
        this.$message({ duration: 2000,showClose: true,message: '请输入手机号',type: 'error' });
        return false;
      }
      if(!this.phoneRegex.test(this.formData.username)){
        this.$message({ duration: 2000,showClose: true,message: '请输入合法手机号',type: 'error' });
        return false;
      }
      if(this.formData.username){
        sendCode({phone:this.formData.username}).then(res => {
          if(res.data.code==200){
            this.$message({ duration: 2000,showClose: true,message: '验证码发送成功,10分钟内有效',type: 'success' });
            // 因为下面用到了定时器，需要保存this指向
            let that = this;
            that.waitTimeLogin--;
            that.getCodeBtnDisableLogin = true;
            this.codeBtnWordLogin = `${this.waitTimeLogin}s 后重新获取`;
            let timer = setInterval(function(){
              if(that.waitTimeLogin>1){
                that.waitTimeLogin--;
                that.codeBtnWordLogin = `${that.waitTimeLogin}s 后重新获取`;
              }else{
                clearInterval(timer)
                that.codeBtnWordLogin = '获取验证码';
                that.getCodeBtnDisableLogin = false;
                that.waitTimeLogin = 61;
              }
            },1000);
          }else{
            this.$message({ duration: 2000,showClose: true,message: res.data.msg,type: 'error' });
          }
        });
      }
    },

    getQueryString(variable) {
      var query = window.location.href;
      var vars = query.split("?");
      for (var i=0;i<vars.length;i++) {
        var pair = vars[i].split("=");
        if(pair[0] == variable){return pair[1];}
      }
      return(false);
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  .head {
    width: 100%;
    height: 70px;
    background-color: rgba(25, 26, 35, 1);
    display: flex;
    align-items: center;
    .head_img {
      width: 50px;
      height: 50px;
      margin-left: 37px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .title {
      font-size: 18px;
      font-weight: 500;
      color: #fff;
      margin-left: 30px;
    }
  }
  .content{
    background-repeat: no-repeat;
  }
  .content {
    position: relative;
    width: 100%;
    // height: calc(100% - 70px);
    height: 100%;
    .login_title{
      position: absolute;
      top: 24%;
      left: 10%;
      z-index: 3;
    }
    .bgColor{
      width:100%;
      height:100%;
      position: absolute;
      // background: rgba(10,191,137,0.5);
      z-index: 1;
      top:0;
      left:0;
    }
    .form_data {
      position: absolute;
      bottom: 24%;
      right: 30px;
      width: 382px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px #cccccc;
      // padding: 62px 55px 62px 55px;
      padding: 62px 55px 46px 55px;
      border-radius:20px;
      z-index: 2;
      h1 {
        font-size: 18px;
      }
      // .el-form {
      //   margin-top: 60px;
      //   margin-top: 40px;
      // }
      .submit {
        width: 100%;
      }
      .forget {
        float: right;
      }
    }
    .footer{
      position: absolute;
      bottom: 30px;
      left: 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      ul{
        display: flex;
        li{
          margin-left: 10px;
        }
      }
      p{
        margin-top: 20px;
        font-weight: 400;
        font-style: normal;
        color: #CCCCCC;
        line-height: 24px;
        text-align: center;
      }
    }
  }
}
</style>
<style>
  .form_data .el-form-item{
    margin-bottom: 24px;
  }
  .el-button.disabled-style {
    background-color: #EEEEEE;
    color: #CCCCCC;
    border-color:#EEEEEE;
  }
  .code-input .el-input__inner, .el-input--underline-default .el-input__inner{
    /* border: none;
    border-bottom: 1px solid #DCDFE6;
    border-top: 1px solid #DCDFE6;
    border-left: 1px solid #DCDFE6;
    border-radius: 4px; */
    border-right:none;
  }
  .code-input .el-input-group__append {
    background: #fff;
    /* color: #2bc58f; */
    color: #437afa;
    cursor: pointer;
    padding:0 10px;
  }
  .code-input .el-input-group__append .el-button{
    font-size: 12px;
  }
  .el-input-group__append button.el-button{
    color: #437afa !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue